import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "38",
  viewBox: "0 0 20 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.6895 21.2136L19.726 14.3883H13.242V9.96117C13.242 8.09345 14.1461 6.27184 17.0502 6.27184H20V0.461165C20 0.461165 17.3242 0 14.7671 0C9.42466 0 5.93607 3.26966 5.93607 9.18641V14.3883H0V21.2136H5.93607V37.7141C7.12785 37.9032 8.34703 38 9.58904 38C10.8311 38 12.0502 37.9032 13.242 37.7141V21.2136H18.6895Z" }, null, -1)
  ])))
}
export default { render: render }